import React from 'react'

import * as Icon from '@makyoapp/makyo-icon/icon'

interface IcProps extends React.PropsWithoutRef<React.SVGProps<SVGElement>> {
  tag?: keyof typeof Icon
}

export default function Ic({ tag, ...props }: IcProps) {
  if (tag) {
    const Tag = Icon[tag]
    return Tag && <Tag {...props} />
  } else {
    return null
  }
}
